import React from 'react'
import { Observable } from 'rxjs'
import { AjaxResponse } from 'rxjs/ajax'
import { getPaymentRegister } from 'utils/api-routes-accounts'
import ReportTablePage from './ReportTablePage'
import { useFinanceObservable } from '../../hooks/useFinanceObservable'
import { FinanceApiResponse } from '../../types/finance'
import formatFinanceDate from '../../utils/formatFinanceDate'

const PaymentRegister = () => {
  const report = useFinanceObservable<any[]>(
    () =>
      getPaymentRegister({}) as any as Observable<
        AjaxResponse<FinanceApiResponse<any[]>>
      >,
  )

  return (
    <ReportTablePage
      title="Payment Register"
      isLoading={report.loading}
      rows={report.data || []}
      columns={[
        { name: 'Number', selector: (row) => row.number || `PAY-${row.id}` },
        { name: 'Direction', selector: (row) => row.payment_direction || '--' },
        {
          name: 'Partner',
          selector: (row) => row.partner_name || row.partner?.name || '--',
        },
        {
          name: 'Payment Date',
          selector: (row) => formatFinanceDate(row.payment_date),
        },
        { name: 'Amount', selector: (row) => row.amount ?? '--' },
        { name: 'Open Amount', selector: (row) => row.open_amount ?? '--' },
        { name: 'State', selector: (row) => row.state || '--' },
      ]}
    />
  )
}

export default PaymentRegister
